import React, { useEffect, useState, useCallback } from 'react';
import S from '../../styled';

// Routes
import { routeNames } from '../../routing/routes';

// Icons
import {
  Bars as BarsIcon
} from '@styled-icons/fa-solid';

// Helpers
import navigateTo from '../../helpers/navigateTo';
import {
  getDelegateRelationshipIdFromLocalStorage,
} from '../../helpers/delegates';

// Model Requests
import { getAccountsByUser } from '../../data/requests/account';
import AccountSwitcher from "../AccountSwitcher";
import styled from "styled-components";

const StyledSelect = styled(S.Select)`
    appearance: none;
    text-align: center;
    border: none;
  `;

export default function TopNav(props) {
  const { history, setStore } = props;
  const { renderNavButton } = props.routeSettings;
  const { account, renderNavigation, token, currentUser } = props.store;
  const [accounts, setAccounts] = useState([]);
  const { setRenderNavigation, setToken } = setStore;

  const [isLoading, setIsLoading] = useState(false);

  const enableSwitchAccount = () => {
    const delegatesEnabled = account?.delegates_enabled;
    const hasDelegateRelationship = typeof getDelegateRelationshipIdFromLocalStorage() === 'string';
    const actingAsDelegate = currentUser?.acting_as_delegate;

    return (delegatesEnabled && hasDelegateRelationship) || actingAsDelegate;
  };

  const getAccounts = useCallback(async () => {
    if (!token) return;

    try {
      setIsLoading(true)
      const data = await getAccountsByUser(token);
      setAccounts(data)
    } catch (error) {
      console.error('getAccountsByUser: ', error);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (account && !isLoading) {
      setIsLoading(true);
    }
    if (accounts && !accounts.length) getAccounts()
  }, [account, accounts, isLoading, getAccounts]);

  const navigateToDashboard = () => {
    navigateTo(history, routeNames.dashboard, token);
  };

  const onAccountChange = (e) => {
    e.preventDefault();
    const token = e.target.value

    setToken(token);
    navigateTo(history, routeNames.dashboard, token);
    window.location.reload();
  };

  const logoUrl = account.portal_logo_url || account.logo_url;
  const accountName = account.portal_brand_name || account.name;

  const toggleNavigation = () => setRenderNavigation(!renderNavigation);

  const logo = (
    <S.Flex row flex={1}>
      <S.Link onClick={navigateToDashboard}>
        <S.NavLogo
          layout={false}
          src={logoUrl}
          alt={`${accountName} logo`}
          initial={isLoading && { scale: 0 }}
          animate={isLoading && { scale: 1 }}
          transition={isLoading && { duration: 1 }}
        />
      </S.Link>
    </S.Flex>
  );

  const accountLogoOrName = () => {
    if (accounts) {
      return (
        <S.Flex column flex={0} flexWrap row paddingTop={20}>
          <S.Visibility mobile>
            {logo}
          </S.Visibility>

          {!enableSwitchAccount() && (
            <S.Flex row flex={1} position={'relative'}>
              <AccountSwitcher logo_url={account.portal_logo_url || account.logo_url}
                               accountName={accountName}/>
              <StyledSelect mediumSize onClick={getAccounts} onChange={onAccountChange}>
                <S.Option key={account.id} value={account.portal_token}>
                  {accountName}
                </S.Option>
                {accounts.map((account) => (
                  <S.Option key={account.id} value={account.portal_token}>
                    {account.portal_brand_name || account.name}
                  </S.Option>
                ))}
              </StyledSelect>
            </S.Flex>
          )}
        </S.Flex>
      );
    } else if (logoUrl) {
      return logo
    } else if (accountName) {
      return <S.Text as="h1">{accountName}</S.Text>;
    } else {
      return null;
    }
  }

  return (
    <S.TopNav>
      <S.Visibility mobile justifyCenter>
        <S.Flex column justifyCenter flex={0}>
          {accountLogoOrName()}
          {renderNavButton && (
              <S.NavButton onClick={toggleNavigation}>
                <BarsIcon />
              </S.NavButton>
          )}
        </S.Flex>
      </S.Visibility>
      <S.Visibility tablet desktop justifyCenter alignCenter>
        <S.Flex justifyCenter alignCenter flex={1}>
          {accountLogoOrName()}
        </S.Flex>
      </S.Visibility>
    </S.TopNav>
  );
}
